module.exports = __webpack_public_path__ + "static/img/20020 (1).46b9e29.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20020 (1).webp
// module id = aduO
// module chunks = 14